var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"odd-object-list"},_vm._l((_vm.objects),function(object){return _c('li',{key:object.id},[_c('objects-item',{attrs:{"object":object,"type":_vm.type}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }